import React, {Component} from 'react';

import axios from "axios/index";
import {withRouter} from 'react-router-dom';
import swal from 'sweetalert2';

import urls from "../../../../../utils/urls";
import {ajaxHandler} from "../../../../../utils/errors";
import {tokenHeader} from "../../../../../utils/headers";
import translator from "../../../../../utils/translations";
import ToggleInput from "../../../../../components/ToggleInput/toggleInput";
import helpers from "../../../../../utils/helpers";
import formatter from "../../../../../utils/formatters";


class DischargePreviousControls extends Component {

    constructor(props) {
        super(props);

        this.state = {
            canEdit: true, //helpers.isUserProvider(this.props.user),
            ajaxInProgress: false,
            trip: this.props.trip,
            discharge: this.props.discharge,
            xhr: false,
            axiosSource: false,

            // Fields
            ground_discharge: null,
            seals_check: null,
            clear_appearance_check: null,
            terminal_sample_temperature: '',
            terminal_sample_density: '',

            origin_reference_density: '',
            terminal_reference_density: '-',
            reference_density_diff: '-',
            density_warning: null,

            origin_alcoholic_grade: '',
            terminal_alcoholic_grade: '-',
            alcoholic_grade_diff: '-',
            alcoholic_warning: null,

            // Convertions
            allow_edition: false,
            edited: false
        }
    }

    _handleToggle = (prop, value) => {
        this.setState({[prop]: value, edited: true});
    };

    _handleInput = (prop, value) => {

        // Custom validations

        this.setState({[prop]: value, edited: true}, () => {
            if(['origin_reference_density', 'terminal_reference_density', 'origin_alcoholic_grade', 'terminal_alcoholic_grade'].indexOf(prop) > -1){
                this._updateDeltas();
            }
            if(['terminal_sample_temperature', 'terminal_sample_density'].indexOf(prop) > -1){
                this._getConversions();
            }
        });
    };

    _getConversions = () => {
        if(!this.state.terminal_sample_temperature || !this.state.terminal_sample_density){
            return false;
        }

        if (this.state.xhr) {
            this.state.axiosSource.cancel('abort');
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.setState({xhr: true, axiosSource: source});

        let data = {
            terminal_sample_temperature: this.state.terminal_sample_temperature,
            terminal_sample_density: this.state.terminal_sample_density
        };

        let CONVERTION_URL = `${urls.API_ROOT}/api/v1/convertions/${this.state.trip.product.code.toLowerCase()}/discharge/`;
        axios.post(CONVERTION_URL, data, {...tokenHeader(), cancelToken: source.token})
            .then((response) => {
                let data = response.data;
                let allow_edition = !data.could_convert;
                let newData = {
                    xhr: false,
                    axiosSource: null,
                    allow_edition,
                };

                if(data.could_convert){
                    if(data.terminal_reference_density){
                        newData['terminal_reference_density'] = data.terminal_reference_density;
                    }
                    if(data.terminal_alcoholic_grade){
                        newData['terminal_alcoholic_grade'] = data.terminal_alcoholic_grade;
                    }
                }

                this.setState(newData, this._updateDeltas);
            })
            .catch((error) => {
                this.setState({trips: [], xhr: false});
                ajaxHandler(error)
            })
    };

    _updateDeltas = () => {

        let newData = {};
        let product = this.state.trip.product;

        let {reference_density_diff, origin_reference_density, terminal_reference_density,
            alcoholic_grade_diff, origin_alcoholic_grade, terminal_alcoholic_grade,
            density_warning, alcoholic_warning} = this.state;

        if(!(origin_reference_density === '' || isNaN(origin_reference_density) || isNaN(terminal_reference_density))){
            reference_density_diff = terminal_reference_density - origin_reference_density;
            reference_density_diff = Math.round(reference_density_diff * 100) / 100;

            if(product && product.density_tolerance){
                density_warning = product.density_tolerance < Math.abs(reference_density_diff)
            }

            newData['reference_density_diff'] = reference_density_diff;
            newData['density_warning'] = density_warning;
        }

        if(!(origin_alcoholic_grade === '' || isNaN(origin_alcoholic_grade) || isNaN(terminal_alcoholic_grade))){
            alcoholic_grade_diff = terminal_alcoholic_grade - origin_alcoholic_grade;
            alcoholic_grade_diff = Math.round(alcoholic_grade_diff * 100) / 100;

            if(product && product.alcoholic_grade_tolerance){
                alcoholic_warning = product.alcoholic_grade_tolerance < Math.abs(alcoholic_grade_diff);
            }

            newData['alcoholic_grade_diff'] = alcoholic_grade_diff;
            newData['alcoholic_warning'] = alcoholic_warning;
        }

        this.setState(newData);
    };

    _submitForm = () => {

        let {seals_check, clear_appearance_check, terminal_sample_temperature,
            terminal_sample_density, origin_reference_density, terminal_reference_density, reference_density_diff,
            origin_alcoholic_grade, terminal_alcoholic_grade, alcoholic_grade_diff, trip, ground_discharge
        } = this.state;

        if(!ground_discharge){
            swal({
                title: 'Error',
                html: '<div class=\'swal-container\'><p>Por favor, realice la descarga a tierra para continuar.</p></div>',
                type: 'error'
            });
            return false;
        }

        if(trip && trip.product && trip.product.check_alcohol){
            if(origin_alcoholic_grade > 100 || terminal_alcoholic_grade > 100){
                swal({
                    title: 'Error en la descarga',
                    html: 'Los valores de graduación alcohólica no pueden ser mayores a 100%',
                    type: 'error'
                });
                return false;
            }
        }


        this.setState({ajaxInProgress: true});
        let data = {
            trip: this.props.trip.id,
            seals_check, clear_appearance_check, terminal_sample_temperature,
            terminal_sample_density, origin_reference_density, terminal_reference_density, reference_density_diff,
            origin_alcoholic_grade, terminal_alcoholic_grade, alcoholic_grade_diff
        };

        Object.keys(data).forEach(key => {if(data[key] === '' || data[key] === '-'){data[key] = null;}});

        const DISCHARGE_URL = `${urls.API_ROOT}/api/v1/discharge/`;
        axios.post(`${DISCHARGE_URL}`, data, tokenHeader())
            .then(this._onSubmitSuccess)
            .catch(this._onSubmitError);

    };

    _onSubmitSuccess = (response) => {
        swal({
            title: 'Descarga',
            html: 'Los controles previos se han ingresado correctamente. Espere unos segundos por favor',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        if(this.state.trip && this.state.trip.discharge.length === 0 && this.props.reloadTrip){
            setTimeout(this.props.reloadTrip, 3000);
        }else{
            setTimeout(() => this.props.updateDischarge(response.data), 3000);
        }
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido crear la descarga',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };

    _goBack = () => {
        if(this.state.edited){
            swal({
                title: 'Atención',
                html: helpers.texts.editionWarning,
                type: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Volver al inicio',
                cancelButtonText: 'Cancelar',
                preConfirm: () => this.props.history.push('/'),
                reverseButtons: true
            });
        }else{
            this.props.history.push('/')
        }

    };

    render() {

        let trip = this.props.trip;
        if(!trip)return <div />;

        // If there's an ajax call in progress or if user can not edit
        let disableButtons = (this.state.ajaxInProgress || !this.state.canEdit);


        let {product} = trip;
        let densityLabel = 'Densidad (Kg/m3)';
        if(product){
            densityLabel = `Densidad a ${formatter.floatFormat(product.terminal_density)}º (Kg/m3)`;
        }

        return (
            <div>
                <div className={"discharge-title-section"}>Controles Previos</div>
                <div className={"row"}>
                    <div className={"col s4"}>
                        <div style={{marginBottom: '30px'}}>
                            <ToggleInput
                                selected={this.state.clear_appearance_check}
                                name={'Aspecto Claro'} stateVar={'clear_appearance_check'}
                                toggleAction={this._handleToggle}
                            />
                            <ToggleInput
                                selected={this.state.seals_check}
                                name={'Precintos según remito'} stateVar={'seals_check'}
                                toggleAction={this._handleToggle}
                            />
                            <ToggleInput
                                selected={this.state.ground_discharge} className={"no-border"}
                                name={'¿Se realizó la descarga a tierra?'} stateVar={'ground_discharge'}
                                toggleAction={this._handleToggle}
                            />
                        </div>
                        <div className={"input-field input-grey"}>
                            <label className="active">Temperatura medida (°C) s/mov.</label>
                            <input placeholder={"Ingrese un valor"} value={this.state.terminal_sample_temperature} type={"number"}
                                   onChange={(ev) => this._handleInput('terminal_sample_temperature', ev.target.value)}
                            />
                        </div>
                        <div className={"input-field input-grey"}>
                            <label className="active">Densidad medida a temp. ambiente</label>
                            <input placeholder={"Ingrese un valor"} value={this.state.terminal_sample_density} type={"number"}
                                   onChange={(ev) => this._handleInput('terminal_sample_density', ev.target.value)}
                            />
                        </div>
                    </div>
                    <div className={"col s4"}>
                        <div className={"discharge-control-box"}>
                            <div className={"discharge-control-box-title"}>{densityLabel}</div>
                            <div className={"row discharge-control-box-body"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Según camion</label>
                                    <input placeholder={"Ingrese un valor"} value={this.state.origin_reference_density} type={"number"}
                                           onChange={(ev) => this._handleInput('origin_reference_density', ev.target.value)}
                                    />
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Según movimientos</label>
                                    {this.state.allow_edition ?
                                        <input placeholder={"Ingrese un valor"}
                                               value={this.state.terminal_reference_density} type={"number"}
                                               onChange={(ev) => this._handleInput('terminal_reference_density', ev.target.value)}
                                        />
                                        :
                                        <p className={"field-p"}>{this.state.terminal_reference_density}</p>
                                    }
                                </div>
                            </div>
                            <div className={"discharge-control-box-footer"}>
                                <div className={"row no-margin"}>
                                    <div className={"col s12 input-field"}>
                                        <label className="active">Diferencia</label>
                                        <p className={"field-p"}>
                                            <span className={`diff-text`}>{this.state.reference_density_diff}</span>
                                            {this.state.density_warning &&
                                            <i className="material-icons shell-red-text">error</i>
                                            }
                                            {this.state.density_warning === false &&
                                            <i className="material-icons green-text">check_circle</i>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {trip && trip.product && trip.product.check_alcohol &&
                    <div className={"col s4"}>
                        <div className={"discharge-control-box"}>
                            <div className={"discharge-control-box-title"}>Grado alcohólico (%)</div>
                            <div className={"row discharge-control-box-body"}>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Según camion</label>
                                    <input placeholder={"Ingrese un valor"} value={this.state.origin_alcoholic_grade} type={"number"}
                                           onChange={(ev) => this._handleInput('origin_alcoholic_grade', ev.target.value)}
                                    />
                                </div>
                                <div className={"col s6 input-field input-grey"}>
                                    <label className="active">Según movimientos</label>
                                    {this.state.allow_edition ?
                                        <input placeholder={"Ingrese un valor"}
                                               value={this.state.terminal_alcoholic_grade} type={"number"}
                                               onChange={(ev) => this._handleInput('terminal_alcoholic_grade', ev.target.value)}
                                        /> :
                                        <p className={"field-p"}>{this.state.terminal_alcoholic_grade}</p>
                                    }
                                </div>
                            </div>
                            <div className={"discharge-control-box-footer"}>
                                <div className={"row no-margin"}>
                                    <div className={"col s12 input-field"}>
                                        <label className="active">Diferencia</label>
                                        <p className={"field-p"}>
                                            <span className={`diff-text`}>{this.state.alcoholic_grade_diff}</span>
                                            {this.state.alcoholic_warning &&
                                            <i className="material-icons shell-red-text">error</i>
                                            }
                                            {this.state.alcoholic_warning === false &&
                                            <i className="material-icons green-text">check_circle</i>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                <div className={"row center"}>
                    <div className={"col s12"}>
                        <button onClick={this._goBack}
                                className={`btn btn-shell-empty z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Volver
                        </button>
                        <button onClick={this._submitForm}
                                className={`btn btn-shell z-depth-0 text-center ${disableButtons ? 'disabled' : ''}`}>
                            Continuar
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(DischargePreviousControls);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/Discharge/DischargePreviousControls.js